import { useState } from "react";
import ProductsNavbar from "../../components/Products/ProductsNavbar";
import ProductsCategories from "./ProductsCategories";
import ProductsBrands from "./ProductsBrands";
import ProductsTags from "./ProductsTags";
import Products from "./Products";
import { useTranslation } from "react-i18next";
import CardHeadeWithActions from "../../components/ui/CardHeadeWithActions";
import OSListsPriceses from "./OSListsPriceses";
import { MwButton } from "../../components/ui";
import { MdOutlineAddBox, MdShoppingCart } from "react-icons/md";

const ProductsHome = () => {
  const [t] = useTranslation("global");
  const [mode, setMode] = useState("List");
  const [tabActive, setTabActive] = useState("Products");

  return (
    <div>
      <CardHeadeWithActions
        icon={<MdShoppingCart size={24} />}
        title={t("product.productsServicesManagement")}
      >
        <MwButton 
          inGroup 
          type="saveBtn" 
          onClick={() => setMode("Add")}
        >
          <MdOutlineAddBox size={18} />
          {t("product.createNewProduct")}
        </MwButton>
      </CardHeadeWithActions>

      <ProductsNavbar tabActive={tabActive} setTabActiive={setTabActive} />

      <div id="content" className="bg-slate-50 rounded-b-lg">
        {tabActive === "Products" && (
          <div className="flex flex-col gap-2 p-3">
            <Products setMode={setMode} mode={mode} />
          </div>
        )}
        {tabActive === "Prices" && (
          <div className="flex flex-col gap-2 p-3">
            <OSListsPriceses />
          </div>
        )}
        {tabActive === "Categories" && (
          <div className="flex flex-col gap-2 p-3">
            <ProductsCategories />
          </div>
        )}
        {tabActive === "Brands" && (
          <div className="flex flex-col gap-2 p-3">
            <ProductsBrands />
          </div>
        )}
        {tabActive === "Tags" && (
          <div className="flex flex-col gap-2 p-3">
            <ProductsTags />
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductsHome;
